import styled from "styled-components";

import { PAGE_MAX_WIDTH } from "@/components/layout/Page/page.utils";

export const StickyHeaderContent = styled.div`
    max-width: ${PAGE_MAX_WIDTH}px;
    padding: 0.5rem 3rem;
    margin: 0 auto;
`;
